import Prismic from 'prismic-javascript';

const prismicKnowledgeHubApiEndpoint =
  process.env.NEXT_PUBLIC_KNOWLEDGE_HUB_PRISMIC_URL;
const prismicKnowledgeHubAccessToken =
  process.env.NEXT_PUBLIC_KNOWLEDGE_HUB_PRISMIC_TOKEN;

export default Prismic.client(prismicKnowledgeHubApiEndpoint, {
  accessToken: prismicKnowledgeHubAccessToken,
});

export const getSimpleClient = (ref = null) =>
  Prismic.getApi(prismicKnowledgeHubApiEndpoint, {
    accessToken: prismicKnowledgeHubAccessToken,
  });

export async function getMainPageByUid(ref) {
  const documents = await getSimpleClient(ref)
    .then((api) =>
      api.query(
        Prismic.Predicates.at('document.type', 'landing_page'),
        ref ? { lang: '*', ref } : { lang: '*' },
      ),
    )
    .then((response) => response.results)
    .catch((error) => {
      console.log(error);
    });

  const mainPageDocument = documents.find((doc) => doc.uid === 'main');

  return mainPageDocument || null;
}

export async function getDocByType(type, options = {}) {
  let documents = [];
  let page = 1;
  let totalPages = 1;

  while (page <= totalPages) {
    const response = await getSimpleClient(options?.ref)
      .then((api) =>
        api.query(Prismic.Predicates.at('document.type', type), {
          ...options,
          pageSize: 100,
          page,
        }),
      )
      .catch((error) => {
        console.log(error);
      });

    if (response && response.results) {
      documents = [...documents, ...response.results];
      totalPages = response.total_pages;
      page += 1;
    } else {
      break;
    }
  }

  return documents;
}

export async function getDocByTypeAndUid(type, uid, options = {}) {
  try {
    const doc = await getSimpleClient()
      .then((api) => api.getByUID(type, uid, options))
      .catch((error) => {
        console.log(error);
        return null;
      });

    return doc || null;
  } catch (error) {
    console.log(error);
    return null;
  }
}
